<template>
  <div class="container">
    <el-row :gutter="15">
      <el-col :span="24">
        <div class="course-left">
          <div class="course-left-ppt">
            <iframe class="course-view" allowfullscreen="true" :src="lessionPlanUrl"></iframe>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import PreviewFile from "@/config/preview-oss";
//import PreviewCdnFile from "@/config/preview-cdn";
import { udpateSchooRemainTraffic } from "@/api/educational";

export default {
  name: "teach-pdf",
  props: {
    curriculumMaterial: Object,
  },
  data() {
    return {
      lessionPlanUrl: "",
      //流量计算
      cost_num: 0, //流量花费大小
      type: "", //流量类型  1ppt 2教案 3学生讲义 4录播课视频 5师训视频 6课堂实录 必填
      preview_url: "", //预览地址
    };
  },
  mounted() {
    console.log("校区教案000", this.curriculumMaterial);
    if (!this.curriculumMaterial.eduId) {
      this.lessionPlanUrl = this.curriculumMaterial.lessionPlanUrl;
    } else {
      console.log("校区教案111");
      console.log(JSON.parse(this.curriculumMaterial.lessionPlanUrl)[0].url);

      var size = JSON.parse(this.curriculumMaterial.lessionPlanUrl)[0].length;
      this.cost_num = parseFloat(size.substring(0, size.length - 2));
      this.preview_url = JSON.parse(
        this.curriculumMaterial.lessionPlanUrl
      )[0].url;
      this.udpateSchooRemainTraffic();
    }
  },
  methods: {
    //更新学校剩余流量
    udpateSchooRemainTraffic() {
      udpateSchooRemainTraffic({
        cost_num: this.cost_num,
        type: "2",
        lession_id: this.curriculumMaterial.id,
      }).then((res) => {
        console.log("更新学校剩余流量");
        console.log(res);
        if (res.is_update) {
          //this.$message.success("流量充足可以查看");
          var _that = this;
          PreviewFile(_that.preview_url, function (res) {
            console.log("校区教案预览地址-watch");
            console.log(res);
            _that.lessionPlanUrl = res;
          });
        }

        if (res.msg == "超出学校剩余流量") {
          this.$message.warning("学校剩余流量不足");
          this.$router.go(-1); //返回上一层
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  background: #f7f8fa;

  .course-left {
    height: calc(100vh - 121px);
    display: flex;
    flex-flow: column;
    background: white;

    .course-left-ppt {
      flex: 6;
      padding-top: 15px;
      padding-right: 15px;
      padding-bottom: 15px;

      .course-view {
        width: 100%;
        height: 100%;
      }
    }

    .course-left-comment {
      flex: 1;

      display: flex;
      flex-flow: column;

      .course-left-comment-title {
        padding: 10px;
        flex: 1;
        font-weight: 500;
      }

      .course-left-comment-content {
        flex: 1;
      }
    }
  }

  .course-right {
    height: calc(100vh - 121px);
    display: flex;
    flex-flow: column;
    background: white;

    .course-right-video {
      flex: 1;

      .course-right-video-title {
        padding: 10px;
        font-weight: 500;
      }

      .course-right-video-desc {
        .coursevideo {
          width: 100%;
          border: 2px solid #dee2e9;
          object-fit: fill;
        }
      }
    }

    .course-right-video1 {
      flex: 2;

      .course-right-video1-title {
        padding: 10px;
        font-weight: 500;
      }

      .course-right-video1-wrapper {
        height: calc((100vh - 81px) / 2 + 50px);
        overflow-y: scroll;
      }

      .videolist {
        border-bottom: 1px solid rgb(199, 199, 198);
        padding-bottom: 10px;
      }

      .course-right-video1-desc {
        .coursevideo1 {
          width: 100%;
          border: 2px solid #dee2e9;
          object-fit: fill;
        }
      }
    }
  }
}
</style>
 